import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import "normalize.css";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

new Vue({
  render: h => h(App)
}).$mount("#app");
